module.exports = __webpack_public_path__ + "h5/img/cygn4.2bfb2622.png";